import { paymentNotificationDefaultParameter } from "../PaymentNotificationParameterForm";
import { salesNotificationDefaultParameter } from "../SalesNotificationParameterForm";
import { salesPartitionDefaultParameter } from "../SalesPartitionParameterForm";

const DEFAULT_PRINT_PARAMETERS = {
  '3' : salesNotificationDefaultParameter,
  '13' : salesNotificationDefaultParameter,
  '6' : paymentNotificationDefaultParameter,
  '5' : salesPartitionDefaultParameter,
}

export default DEFAULT_PRINT_PARAMETERS;